<span *ngIf="show">
  <ng-content></ng-content>
</span>
